/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NgxCrudGridComponent as ɵe} from './lib/ngx-crud-layout/components/ngx-crud-grid/ngx-crud-grid.component';
export {NgxCrudManageDialogComponent as ɵc} from './lib/ngx-crud-layout/components/ngx-crud-manage-dialog/ngx-crud-manage-dialog.component';
export {NgxCrudManageLayoutComponent as ɵd} from './lib/ngx-crud-layout/components/ngx-crud-manage-layout/ngx-crud-manage-layout.component';
export {NgxCrudManageComponent as ɵb} from './lib/ngx-crud-layout/components/ngx-crud-manage/ngx-crud-manage.component';
export {NgxFullpageLoaderComponent as ɵa} from './lib/ngx-wrapper-shared/ngx-fullpage-loader/ngx-fullpage-loader.component';